import React, { memo } from 'react'
import { Roller } from 'react-awesome-spinners'

const Spinner = (props) => <Roller color={'#80506F'} {...props} />

export default memo(Spinner)
